import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=0eea9d6c&"
import script from "./DialogWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eea9d6c')) {
      api.createRecord('0eea9d6c', component.options)
    } else {
      api.reload('0eea9d6c', component.options)
    }
    module.hot.accept("./DialogWrapper.vue?vue&type=template&id=0eea9d6c&", function () {
      api.rerender('0eea9d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/dialog/DialogWrapper.vue"
export default component.exports